// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%2364748b%27%3E%3Cpath d=%27M4 6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm2 0v12h12V6H6zm4 2a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1zm4 0a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AssigneesPage Styles */

.assignees-page {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

/* Page Header */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.header-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.page-title {
  font-size: 1.875rem;
  font-weight: 900;
  color: var(--text-main);
  margin: 0;
  letter-spacing: -0.02em;
}

.page-subtitle {
  font-size: 0.875rem;
  color: var(--text-sub);
  margin: 0;
}

/* Filters Bar */
.filters-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem;
  background-color: var(--surface-light);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  flex-wrap: wrap;
}

.filter-tabs {
  display: flex;
  gap: 0.25rem;
  padding: 0.25rem;
  background-color: var(--slate-100);
  border-radius: var(--radius-lg);
}

.filter-tab {
  padding: 0.375rem 1rem;
  border-radius: var(--radius-md);
  background: transparent;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-sub);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.filter-tab:hover {
  color: var(--text-main);
}

.filter-tab.active {
  background-color: var(--surface-light);
  color: var(--text-main);
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.search-wrapper {
  position: relative;
  width: 20rem;
}

.search-wrapper .material-symbols-outlined {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-sub);
  font-size: 20px;
}

.search-wrapper .form-input {
  width: 100%;
  padding: 0.5rem 0.75rem 0.5rem 2.5rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  font-size: 0.875rem;
  background-color: var(--surface-light);
}

.search-wrapper .form-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 2px var(--primary-light);
}

/* Card & Table */
.card {
  background-color: var(--surface-light);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.table thead {
  background-color: var(--slate-50);
  border-bottom: 1px solid var(--border-color);
}

.table th {
  padding: 1rem 1.5rem;
  text-align: left;
  font-weight: 600;
  color: var(--text-sub);
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

/* Column widths for Assignees */
.table th:nth-child(1) { width: 6%; }  /* SN - compact */
.table th:nth-child(2) { width: 8%; }  /* Cover - compact, fixed */
.table th:nth-child(3) { width: 30%; } /* Title - largest, multi-line */
.table th:nth-child(4) { width: 20%; } /* Borrower Name - large, multi-line */
.table th:nth-child(5) { width: 10%; } /* Issued Date - compact */
.table th:nth-child(6) { width: 10%; } /* Return Date - compact */
.table th:nth-child(7) { width: 6%; }  /* Status - compact */
.table th:nth-child(8) { width: 10%; } /* Actions - compact */

/* Book cover column - center the image */
.book-cover-column {
  text-align: center;
  vertical-align: middle !important;
  padding: 0.75rem 0.75rem !important;
}

.book-cover-inline {
  width: 48px;
  height: 64px;
  object-fit: cover;
  border-radius: var(--radius-md);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border-color);
}

.book-cover-placeholder-inline {
  width: 48px;
  height: 64px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.book-cover-placeholder-inline .material-symbols-outlined {
  font-size: 24px;
  color: #64748b;
}

.book-cover-column .book-cover-inline,
.book-cover-column .book-cover-placeholder-inline {
  margin: 0 auto;
  display: block;
}

/* Book title column - allow wrapping */
.book-title-column {
  white-space: normal;
  vertical-align: middle;
  max-width: 300px;
}

.book-title-text {
  word-break: break-word;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.table td {
  padding: 0.75rem 1.25rem;
  border-top: 1px solid var(--border-color);
  color: var(--text-main);
  vertical-align: middle;
  height: 80px;
  box-sizing: border-box;
}

/* Compact date cells */
.table td:nth-child(5),
.table td:nth-child(6) {
  padding: 0.75rem 1rem;
  font-size: 0.8125rem;
  white-space: nowrap;
}

/* SN, Status, Actions - compact */
.table td:nth-child(1),
.table td:nth-child(2),
.table td:nth-child(7),
.table td:nth-child(8) {
  white-space: nowrap;
}

/* Title and Borrower Name cells - allow wrapping */
.table td:nth-child(3),
.table td:nth-child(4) {
  white-space: normal;
  vertical-align: middle;
}

.table tbody tr {
  transition: background-color var(--transition-fast);
}

.table tbody tr:hover {
  background-color: var(--slate-50);
}

.font-medium {
  font-weight: 600;
}

.text-sub {
  color: var(--text-sub);
}

/* Status Badge */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: var(--radius-full);
  border: 1px solid;
}

.status-borrowed {
  background-color: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
}

.status-returned {
  background-color: #dcfce7;
  color: #166534;
  border-color: #86efac;
}

/* Actions */
.actions {
  display: flex;
  gap: 0.25rem;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: var(--radius-md);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.action-btn.return {
  color: var(--primary);
}

.action-btn.return:hover {
  color: var(--primary-dark);
  background-color: var(--primary-light);
}

.action-btn.danger {
  color: var(--text-sub);
}

.action-btn.danger:hover {
  color: #dc2626;
  background-color: #fef2f2;
}

.action-btn .material-symbols-outlined {
  font-size: 18px;
}

/* Table Footer */
.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background-color: var(--slate-50);
  border-top: 1px solid var(--border-color);
}

.pagination-info {
  font-size: 0.875rem;
  color: var(--text-sub);
  margin: 0;
}

.pagination-info strong {
  color: var(--text-main);
  font-weight: 600;
}

.pagination-buttons {
  display: flex;
  gap: 0.5rem;
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .filters-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-tabs {
    overflow-x: auto;
  }

  .search-wrapper {
    width: 100%;
  }

  .table-container {
    overflow-x: auto;
  }

  .table {
    min-width: 800px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AssigneesPage.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,sCAAsC;EACtC,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC,yBAAyB,SAAS,EAAE,GAAG,iBAAiB;AACxD,yBAAyB,SAAS,EAAE,GAAG,2BAA2B;AAClE,yBAAyB,UAAU,EAAE,EAAE,gCAAgC;AACvE,yBAAyB,UAAU,EAAE,EAAE,sCAAsC;AAC7E,yBAAyB,UAAU,EAAE,EAAE,0BAA0B;AACjE,yBAAyB,UAAU,EAAE,EAAE,0BAA0B;AACjE,yBAAyB,SAAS,EAAE,GAAG,qBAAqB;AAC5D,yBAAyB,UAAU,EAAE,EAAE,sBAAsB;;AAE7D,yCAAyC;AACzC;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,6DAA6D;EAC7D,yDAAmU;EACnU,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;;;;EAIE,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* AssigneesPage Styles */\n\n.assignees-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* Page Header */\n.page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.header-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.page-title {\n  font-size: 1.875rem;\n  font-weight: 900;\n  color: var(--text-main);\n  margin: 0;\n  letter-spacing: -0.02em;\n}\n\n.page-subtitle {\n  font-size: 0.875rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n/* Filters Bar */\n.filters-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem;\n  background-color: var(--surface-light);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n  flex-wrap: wrap;\n}\n\n.filter-tabs {\n  display: flex;\n  gap: 0.25rem;\n  padding: 0.25rem;\n  background-color: var(--slate-100);\n  border-radius: var(--radius-lg);\n}\n\n.filter-tab {\n  padding: 0.375rem 1rem;\n  border-radius: var(--radius-md);\n  background: transparent;\n  border: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-sub);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.filter-tab:hover {\n  color: var(--text-main);\n}\n\n.filter-tab.active {\n  background-color: var(--surface-light);\n  color: var(--text-main);\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.search-wrapper {\n  position: relative;\n  width: 20rem;\n}\n\n.search-wrapper .material-symbols-outlined {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-sub);\n  font-size: 20px;\n}\n\n.search-wrapper .form-input {\n  width: 100%;\n  padding: 0.5rem 0.75rem 0.5rem 2.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  font-size: 0.875rem;\n  background-color: var(--surface-light);\n}\n\n.search-wrapper .form-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px var(--primary-light);\n}\n\n/* Card & Table */\n.card {\n  background-color: var(--surface-light);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.table thead {\n  background-color: var(--slate-50);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.table th {\n  padding: 1rem 1.5rem;\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-sub);\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n}\n\n/* Column widths for Assignees */\n.table th:nth-child(1) { width: 6%; }  /* SN - compact */\n.table th:nth-child(2) { width: 8%; }  /* Cover - compact, fixed */\n.table th:nth-child(3) { width: 30%; } /* Title - largest, multi-line */\n.table th:nth-child(4) { width: 20%; } /* Borrower Name - large, multi-line */\n.table th:nth-child(5) { width: 10%; } /* Issued Date - compact */\n.table th:nth-child(6) { width: 10%; } /* Return Date - compact */\n.table th:nth-child(7) { width: 6%; }  /* Status - compact */\n.table th:nth-child(8) { width: 10%; } /* Actions - compact */\n\n/* Book cover column - center the image */\n.book-cover-column {\n  text-align: center;\n  vertical-align: middle !important;\n  padding: 0.75rem 0.75rem !important;\n}\n\n.book-cover-inline {\n  width: 48px;\n  height: 64px;\n  object-fit: cover;\n  border-radius: var(--radius-md);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  border: 1px solid var(--border-color);\n}\n\n.book-cover-placeholder-inline {\n  width: 48px;\n  height: 64px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2364748b'%3E%3Cpath d='M4 6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm2 0v12h12V6H6zm4 2a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1zm4 0a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1z'/%3E%3C/svg%3E\");\n  background-size: 24px;\n  background-repeat: no-repeat;\n  background-position: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.book-cover-placeholder-inline .material-symbols-outlined {\n  font-size: 24px;\n  color: #64748b;\n}\n\n.book-cover-column .book-cover-inline,\n.book-cover-column .book-cover-placeholder-inline {\n  margin: 0 auto;\n  display: block;\n}\n\n/* Book title column - allow wrapping */\n.book-title-column {\n  white-space: normal;\n  vertical-align: middle;\n  max-width: 300px;\n}\n\n.book-title-text {\n  word-break: break-word;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.table td {\n  padding: 0.75rem 1.25rem;\n  border-top: 1px solid var(--border-color);\n  color: var(--text-main);\n  vertical-align: middle;\n  height: 80px;\n  box-sizing: border-box;\n}\n\n/* Compact date cells */\n.table td:nth-child(5),\n.table td:nth-child(6) {\n  padding: 0.75rem 1rem;\n  font-size: 0.8125rem;\n  white-space: nowrap;\n}\n\n/* SN, Status, Actions - compact */\n.table td:nth-child(1),\n.table td:nth-child(2),\n.table td:nth-child(7),\n.table td:nth-child(8) {\n  white-space: nowrap;\n}\n\n/* Title and Borrower Name cells - allow wrapping */\n.table td:nth-child(3),\n.table td:nth-child(4) {\n  white-space: normal;\n  vertical-align: middle;\n}\n\n.table tbody tr {\n  transition: background-color var(--transition-fast);\n}\n\n.table tbody tr:hover {\n  background-color: var(--slate-50);\n}\n\n.font-medium {\n  font-weight: 600;\n}\n\n.text-sub {\n  color: var(--text-sub);\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.625rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: var(--radius-full);\n  border: 1px solid;\n}\n\n.status-borrowed {\n  background-color: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5;\n}\n\n.status-returned {\n  background-color: #dcfce7;\n  color: #166534;\n  border-color: #86efac;\n}\n\n/* Actions */\n.actions {\n  display: flex;\n  gap: 0.25rem;\n}\n\n.action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border-radius: var(--radius-md);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.action-btn.return {\n  color: var(--primary);\n}\n\n.action-btn.return:hover {\n  color: var(--primary-dark);\n  background-color: var(--primary-light);\n}\n\n.action-btn.danger {\n  color: var(--text-sub);\n}\n\n.action-btn.danger:hover {\n  color: #dc2626;\n  background-color: #fef2f2;\n}\n\n.action-btn .material-symbols-outlined {\n  font-size: 18px;\n}\n\n/* Table Footer */\n.table-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  background-color: var(--slate-50);\n  border-top: 1px solid var(--border-color);\n}\n\n.pagination-info {\n  font-size: 0.875rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n.pagination-info strong {\n  color: var(--text-main);\n  font-weight: 600;\n}\n\n.pagination-buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .page-title {\n    font-size: 1.5rem;\n  }\n\n  .filters-bar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filter-tabs {\n    overflow-x: auto;\n  }\n\n  .search-wrapper {\n    width: 100%;\n  }\n\n  .table-container {\n    overflow-x: auto;\n  }\n\n  .table {\n    min-width: 800px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
